import { faCircle, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import DeletePopupuo from "./DeletePopupuo";
import axios from "axios";
import { AuthContext } from "../AuthContext";

const FeedbackDashboard = () => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemToDelete, setItemToDelete] = useState(null);
  const { auth } = useContext(AuthContext);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const itemsPerPage = 3;

  const paginate = (items, currentPage, itemsPerPage) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  };

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axios.get("https://sychoclinicapi.runasp.net/api/feedbacks");
      setData(response.data);
      setLoading(false)
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)

    }
  };

  useEffect(() => {
    fetchData();
    
  }, []);

  const handleDeleteClick = (feedId) => {
    setItemToDelete(feedId);
    setShowDeletePopup(true);
  };

  const handleDeleteConfirm = async () => {
    if (!itemToDelete) return;
    const token = auth.token;
    setLoading(true)

    try {
      await axios.delete(`https://sychoclinicapi.runasp.net/api/feedbacks/${itemToDelete}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      
      setData(data.filter((feed) => feed.id !== itemToDelete));
      console.log("Delete successful:", itemToDelete);
setLoading(false)
      setShowDeletePopup(false);
      setItemToDelete(null);
    } catch (error) {
      console.error("Error deleting the feedback:", error);
      setShowDeletePopup(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeletePopup(false);
    setItemToDelete(null);
  };

  return (
    <div id="feedbackDashboard">
      {loading && (
        <div
          style={{
            backgroundColor: "#EEE",
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            zIndex: "1000",
            opacity: ".6",
          }}
        >
          <span className="spinner-border text-dark" role="status"></span>
        </div>
      )}
      {showDeletePopup && (
        <DeletePopupuo
          handleDeleteConfirm={handleDeleteConfirm}
          handleDeleteCancel={handleDeleteCancel}
        />
      )}
      <section className="vh-100 w-100 d-flex justify-content-center align-items-center flex-column">
        <h4 className="mt-0 ms-0 pb-1" style={{ textDecoration: "underline blue" }}>
          Feedbacks
        </h4>

        <div className="col-lg-8 col-md-10 col-sm-12 h-75 w-sm-100 w-md-50 w-lg-50">
          <div className="d-flex align-items-center justify-content-center flex-wrap py-2 px-2 gap-2 mb-5">
            <div className="border border-secondary bg-primary text-white shadow rounded-3 px-5 py-2">
              <div className="">
                <FontAwesomeIcon className="text-white bg-white rounded-circle me-1" icon={faCircle} />
                latest feedbacks
              </div>
              <span className="fw-bold ps-3">{data.length}</span>
            </div>
            
          </div>
          <div className="d-flex justify-content-center align-items-center flex-column bgHome px-2 py-2 rounded">
            <div
              style={{
                borderBottom: "1px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <h4 className="py-2 px-4">All Feedbacks</h4>
              <div className="d-flex gap-4" style={{ position: "relative", cursor: "pointer" }}></div>
            </div>

            <div className="w-100 px-1 py-2 container">
              <ul className="w-100 px-3 row gap-3 justify-content-center">
                {paginate(data, currentPage, itemsPerPage).map((feed) => (
                  <li
                    key={feed.id}
                    className="position-relative col-12 col-lg-10 bg-white d-flex px-1 py-3 rounded-4 my-2 gap-0 align-items-center"
                  >
                    <div
                      className="h-75 rounded-circle mb-3 ms-1 me-3 mt-2 d-flex align-items-start justify-content-center"
                    >
                      <span
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "90px",
                          height: "90px",
                          color: "blue",
                          fontSize: "40px",
                          fontWeight: "bold",
                          backgroundColor: "black",
                        }}
                      >
                        {feed?.name?.charAt(0)}
                      </span>
                    </div>

                    <div>
                      <div>
                        <h6 style={{ overflowX: "hidden", fontSize: "16px" }}>{feed.name}</h6>
                        <p style={{ fontSize: "13px" }}>{feed.feedback}</p>
                      </div>

                      <div className="flex-row px-2 flex-wrap d-flex gap-5 mt-4 justify-content-between align-items-center w-100">
                        <span
                          className="btn btn-danger text-white rounded-pill px-5"
                          onClick={() => handleDeleteClick(feed.id)}
                        >
                          Delete
                        </span>

                        <div className="right text-warning">
                          <FontAwesomeIcon className="px-1" icon={faStar} />
                          <FontAwesomeIcon className="px-1" icon={faStar} />
                          <FontAwesomeIcon className="px-1" icon={faStar} />
                          <FontAwesomeIcon className="px-1" icon={faStar} />
                          <FontAwesomeIcon className="px-1" icon={faStar} />
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={data.length}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const Pagination = ({ itemsPerPage, totalItems, currentPage, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="mx-auto w-100 d-flex justify-content-center">
      <ul className="pagination mx-auto">
        {pageNumbers.map((number) => (
          <li key={number} className={`page-item ${number === currentPage ? "active" : ""}`}>
            <button onClick={() => onPageChange(number)} className="page-link">
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FeedbackDashboard;
